/**
 * A function for debouncing inside another function by passing it in with the arguments and interval.
 *
 * @param {Function} func The function being debounced
 * @param {Array} args The arguments passed to the function being debounced
 * @param {number} time The amount of time in milliseconds to debounce the function call
 * @returns {boolean} Whether or not the function should be debounced
 * @example
 *   function exampleFunc(arg1, arg2) {
 *     // Exit the function if it should be debounced
 *     if (debounce(exampleFunc, arguments, 250)) {
 *       return;
 *     }
 *     // Execute the rest of the function when done debouncing
 *   }
 */
function debounce(func, args, time) {
  debounce.data[func] = debounce.data[func] || {};
  clearTimeout(debounce.data[func].timeout);

  if (debounce.data[func].shouldDebounce === false) {
    delete debounce.data[func];

    return false;
  }

  debounce.data[func].timeout = setTimeout(() => {
    debounce.data[func].shouldDebounce = false;
    args = Array.prototype.slice.call(args);
    func(...args);
  }, time);

  return true;
}

debounce.data = {};

export default debounce;
